import { render } from "./RecentTradeFeed.vue?vue&type=template&id=316d9b2e&ts=true"
import script from "./RecentTradeFeed.vue?vue&type=script&lang=ts"
export * from "./RecentTradeFeed.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__